import type { NotificationOut } from '@myrentalmate/api-client';
import { Chip } from '@mui/material';

import { DataTable, type DataColumn } from '../../components/DataTable';
import { formatDateTime } from '../../lib/format';

const STATUS: Record<
  NotificationOut['status'],
  { label: string; color: 'success' | 'error' | 'default' }
> = {
  sent: { label: 'Sent', color: 'success' },
  failed: { label: 'Failed', color: 'error' },
  queued: { label: 'Sending', color: 'default' },
};

const COLUMNS: DataColumn<NotificationOut>[] = [
  { label: 'When', render: (m) => formatDateTime(m.created_at) },
  { label: 'To', render: (m) => m.to_address },
  { label: 'Subject', render: (m) => m.subject },
  {
    label: 'Status',
    render: (m) => (
      <Chip size="small" color={STATUS[m.status].color} label={STATUS[m.status].label} />
    ),
  },
];

/** What was sent and whether it went. "Sent" means our email service took it, not that it arrived. */
export function MessageTable({ messages }: { messages: NotificationOut[] }) {
  return <DataTable columns={COLUMNS} rows={messages} rowKey={(m) => m.id} />;
}
